export default __webpack_public_path__ + "static/media/celebracion (1).6d85aa6c.png";